import { render, staticRenderFns } from "./tenanAgree.vue?vue&type=template&id=98780ec8&"
import script from "./tenanAgree.vue?vue&type=script&lang=js&"
export * from "./tenanAgree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports